module.exports = __webpack_public_path__ + "static/media/pragmatic2000m.e3cf37fa.webp";